import { render, staticRenderFns } from "./CommonFooterItems.vue?vue&type=template&id=4ba0b8aa&scoped=true&"
import script from "./CommonFooterItems.vue?vue&type=script&lang=js&"
export * from "./CommonFooterItems.vue?vue&type=script&lang=js&"
import style0 from "./CommonFooterItems.vue?vue&type=style&index=0&id=4ba0b8aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba0b8aa",
  null
  
)

export default component.exports